<div #root class="svm">
  <button
    #trigger
    type="button"
    class="svm__trigger"
    [class.svm__trigger--active]="activeName() !== null"
    [attr.aria-expanded]="open()"
    aria-haspopup="menu"
    aria-controls="saved-views-panel"
    (click)="toggle()"
  >
    <span class="svm__star" aria-hidden="true">★</span>
    <span class="svm__trigger-label">
      {{ activeName() ?? ('savedViews.button' | translate) }}
    </span>
    <span class="svm__count">{{ viewsCount() }}</span>
    <mat-icon class="svm__chevron" [class.svm__chevron--open]="open()" aria-hidden="true">chevron_right</mat-icon>
  </button>

  @if (open()) {
    <div id="saved-views-panel" class="svm__panel" [class.svm__panel--align-right]="alignRight()" role="menu">
      <div class="svm__panel-heading">{{ 'savedViews.heading' | translate }}</div>

      @if (views().length === 0) {
        <div class="svm__empty">{{ 'savedViews.empty' | translate }}</div>
      }

      @for (view of views(); track view.name) {
        <div class="svm__item" [class.svm__item--active]="activeName() === view.name" role="none">
          <button
            type="button"
            class="svm__item-btn"
            role="menuitemradio"
            [attr.aria-checked]="activeName() === view.name"
            (click)="onSelect(view.name)"
          >
            <span class="svm__item-name">{{ view.name }}</span>
            <span class="svm__item-summary">{{ view.summary }}</span>
          </button>
          @if (activeName() === view.name) {
            <span class="svm__item-check" aria-hidden="true">✓</span>
          }
          <button
            type="button"
            class="svm__item-delete"
            [attr.aria-label]="'savedViews.deleteAria' | translate: { name: view.name }"
            (click)="onDelete($event, view.name)"
          >
            ×
          </button>
        </div>
      }

      <div class="svm__save-row">
        @if (showUpdate()) {
          <button type="button" class="svm__update-btn" data-testid="saved-view-update" (click)="update()">
            <span aria-hidden="true">✓</span>
            {{ 'savedViews.update' | translate: { name: activeName() } }}
          </button>
        }
        <div class="svm__save-label">
          {{ saveHeadingKey() | translate }}
        </div>
        <div class="svm__save-controls">
          <input
            type="text"
            class="svm__save-input"
            [attr.placeholder]="'savedViews.namePlaceholder' | translate"
            [attr.aria-label]="'savedViews.namePlaceholder' | translate"
            [attr.maxlength]="nameMax"
            [attr.aria-describedby]="atNameMax() ? 'saved-view-name-hint' : null"
            [value]="nameInput()"
            (input)="onNameInput($event)"
            (keydown)="onSaveKey($event)"
          />
          <button type="button" class="svm__save-btn" [disabled]="!canSave()" (click)="save()">
            {{ 'savedViews.saveButton' | translate }}
          </button>
        </div>
        @if (atNameMax()) {
          <div id="saved-view-name-hint" class="svm__name-hint" data-testid="saved-view-name-hint">
            {{ 'savedViews.nameMaxHint' | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
